var render = function render(){var _vm=this,_c=_vm._self._c;return (this.marketing_card.product_mode === 1)?_c('article',{staticClass:"preview-product-price-container ml-3"},[_c('h3',[_vm._v("商品資訊設定")]),_c('span',{ref:"product-text",staticClass:"product-text-container",style:({
            display: 'block',
            boxSizing: 'border-box',
            wordBreak: 'break-word',
            fontSize: _vm.marketing_card.product_text_size,
            color: _vm.marketing_card.product_text_color,
            lineHeight: '1',
            textAlign: 'left',
            fontFamily: 'Noto Sans TC,Noto Sans JP,sans-serif',
            fontWeight: 'normal !important',
            marginBottom: '5px',
        })},[_vm._v(" "+_vm._s(_vm.marketing_card.product_text)+" ")]),_c('div',{staticStyle:{"dispaly":"inline-block","box-sizing":"border-box","text-align":"left"}},[_c('span',{ref:"discount_price",staticClass:"discount-price-container",style:({
                display: 'block',
                boxSizing: 'border-box',
                wordBreak: 'break-word',
                fontSize:  _vm.marketing_card.discount_price_size,
                color:  _vm.marketing_card.discount_price_color,
                textAlign: 'left',
                lineHeight: '1',
                fontFamily: 'Noto Sans TC,Noto Sans JP,sans-serif',
                fontWeight: 'normal !important',
            })},[_vm._v(" "+_vm._s(_vm.marketing_card.discount_price)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }